<template>
  <div class="modal-container">
    <div class="blur-backdrop" @click="close" />
    <div class="modal invite-link-modal">
      <div class="explanatory-text invite-link-modal">
        <div>
          Share this invite link with anyone.
        </div>
        <div>
          This link will expire in 1 week.
        </div>
      </div>
      <transition name="pop-from-top">
        <div
          v-show="displayCopiedMessage"
          class="copied-message-item"
        >
          Copied Invite Link!
        </div>
      </transition>
      <div class="invite-link-container">
        <Spinner v-if="!inviteLink" color="teal" />
        <div v-else>
          {{ inviteLink }}
        </div>
        <span
          v-if="isClipboardAPIAvailable"
          @click="copyRoomcodeToClipboard"
          class="copy-button"
        >
          <font-awesome-icon :icon="['fas', 'copy']" />
        </span>
      </div>
      <SpinnerButton
        class="button"
        :showSpinner="false"
        @click="close"
      >
        Close
      </SpinnerButton>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Spinner from '@/components/utilComponents/Spinner';
import SpinnerButton from '@/components/utilComponents/SpinnerButton';

export default Vue.extend({
  name: 'InviteLinkModal',
  components: {
    Spinner,
    SpinnerButton
  },
  data: () => ({
    inviteLink: '',
    isClipboardAPIAvailable: false,
    displayCopiedMessage: false,
  }),
  computed: {
    auth0UserId: function () {
      return this.$auth.user.sub.replace(/\|/g, '_');
    },
    idToken: function () {
      return this.$auth.idToken;
    }
  },
  methods: {
    async generateInviteLink() {
      try {
        const response = await this.axios.post(`${ process.env.VUE_APP_BACKEND_API_URL }/generateinvitelink`, {
          auth0UserId: this.auth0UserId
        }, {
          headers: {
            'Content-Type': 'application/json', 
            'Authorization': `Bearer ${this.idToken}`
          }
        });

        this.inviteLink = response.data.inviteLink;
      } catch (error) {
        console.log('Error:', error);
      }
    },
    async copyRoomcodeToClipboard() {
      await navigator.clipboard.writeText(this.inviteLink);
      this.displayCopiedMessage = true;
      await setTimeout(() => {
        this.displayCopiedMessage = false;
      }, 2000);
    },
    close() {
      this.$emit('close');
    }
  },
  created: async function() {
    await this.generateInviteLink();
    this.isClipboardAPIAvailable = !!navigator.clipboard;
  }
})
</script>

<style scoped lang="scss">
@import '@/styles/modal-styles.scss';

.invite-link-container {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: $pantone-blue;
}

.copied-message-item {
  position: absolute;
  top: calc(50% - 0.75em);
  right: -8.5em;
  padding: 0.4em 0.8em;
  border-radius: 0.3em;
  background-color: $baby-blue;
}

.copy-button {
  cursor: pointer;
  padding-left: 0.6em;
  color: $dark-brown;
  &:hover {
    color: $eigengrau;
  }
}

</style>
